export const filterVariants = (
  productObject,
  embroideryOptionPosition,
  embroidery = false,
  sizeOptionPosition = 1,
  activeSize = null,
  appliqueOptionAvailable = false
) => {
  // Determine the correct embroidery/applique option value
  let embroideryVal = "no embroidery"; // Default to no embroidery

  if (appliqueOptionAvailable) {
    embroideryVal = "applique"; // If applique mode is enabled, filter applique variants
  } else if (embroidery) {
    embroideryVal = "embroidery"; // Otherwise, filter for embroidery
  }

  const variants = productObject.variants.filter((variant) => {
    // If no variants are set up, return default
    if (variant.title === "Default Title") return variant;

    if (activeSize !== null && embroideryOptionPosition) {
      // Filter based on both size and embroidery/applique option
      return (
        variant[`option${sizeOptionPosition}`] === activeSize &&
        variant[`option${embroideryOptionPosition}`].toLowerCase() === embroideryVal
      );
    }
    
    if (embroideryOptionPosition) {
      // Filter based on embroidery/applique type only
      return variant[`option${embroideryOptionPosition}`].toLowerCase() === embroideryVal;
    }

    if (sizeOptionPosition > 1) {
      return variant[`option${sizeOptionPosition}`] === activeSize;
    }

    return variant;
  });

  return variants;
};
